import {ChangeDetectionStrategy, Component, ElementRef, ViewChild, ViewEncapsulation, Inject, OnInit} from "@angular/core";

declare let $:any;

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
  selector: 'site-app',
  // styles: [ require('./site-app.component.css') ],
  template: require('./site-app.component.html')
})
export class SiteAppComponent implements OnInit {
  // mobile navigation
  isBrowser: boolean;

  constructor(@Inject('isBrowser') isBrowser: boolean){
    this.isBrowser = isBrowser;
  }


  ngOnInit(): void {
    if(this.isBrowser){
      this.initAnimations();
      this.scrollEvent();
    }
  }

  @ViewChild("novoModalDiv") novoModalDiv: ElementRef;
  
  scrollEvent(){
    $(window).scroll(function() {
        if ($(window).scrollTop() > 100) {
            $(".scroll-top").show();
        }
        else {
            $(".scroll-top").hide();
        }
    });
  }

  initAnimations(){
    $(".scroll-top").click(function() {
    $('html,body').animate({
        scrollTop: $(".site-header").offset().top},
        'slow');
    });
  }

  openNav(){
    $("#myNav").height("100%");
    $(".scroll-top").hide();
  }

  closeNav(){
    $("#myNav").height("0%");
    $(".scroll-top").show();
  }

  // open Novo modal
  openNovoModal(){
      $(".modal-Novo").show();
      $(this.novoModalDiv.nativeElement).modal('show');
      console.log("yes");
  }

  closeNovoModal(){
    $(this.novoModalDiv.nativeElement).modal('hide');
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/+site-app/site-app.component.ts